export default class Webshop {

    static initializeEvents() {
        this.cartEvents();
        this.productQueryEvents();
        this.productFiltersEvents();
        this.showFiltersEvents();
        this.showMoreEvents();
        this.searchInEditoContent();
    }

    static cartEvents() {
        // Add products count on cart header link in header
        document.body.addEventListener('ibexa-cart:cart-data-changed', event => {
            const productsCount = event.detail.cart.getEntries().reduce((a, b) => a + b.quantity, 0);

            Array
                .from(document.querySelectorAll('.header-items .header-tools a[href]'))
                .forEach(item => {
                    if (item.innerText.toLowerCase().includes('panier')) {
                        if (productsCount === 0) {
                            item.firstChild.nodeValue = 'Mon panier';
                        } else {
                            item.firstChild.nodeValue = 'Mon panier (' + productsCount + ' article' + (productsCount > 1 ? 's' : '') + ')';
                        }
                    }
                });
        });
    }

    static productQueryEvents() {
        // Remove product list query on click
        Array
            .from(document.querySelectorAll('.webshop-remove-query-button'))
            .forEach(button => button.addEventListener('click', event => {
                event.preventDefault();

                const urlParameters = new URLSearchParams(window.location.search);
                urlParameters.delete('product_list[query]');
                window.location.search = urlParameters.toString();
            }));
    }

    static productFiltersEvents() {
        // Remove product list filter on click
        Array
            .from(document.querySelectorAll('.webshop-remove-filter-button'))
            .forEach(button => button.addEventListener('click', event => {
                event.preventDefault();

                const targetFilterName = event.currentTarget.getAttribute('data-filter-name');
                const targetFilterLabel = event.currentTarget.getAttribute('data-filter-value');
                const targetFilterInput = document.querySelector('.ibexa-store-choice__input[name="product_list[filters][' + targetFilterName + '][]"][value="' + targetFilterLabel + '"]');

                targetFilterInput.checked = false;

                const searchQuery = document.querySelectorAll('.search-product_publication-text');
                if (typeof searchQuery !== 'undefined') {
                    let search_query = document.createElement('input');

                    search_query.setAttribute("value", searchQuery[0].value);
                    search_query.setAttribute("type", "hidden");
                    search_query.setAttribute("name", "product_list[query]");
                    search_query.setAttribute("id", "product_list_query");
                    search_query.setAttribute("form", "product_list");
                    targetFilterInput.closest('form').appendChild(search_query);
                }
                targetFilterInput.closest('form').submit();
            }));
    }

    static showFiltersEvents() {
        const showFiltersBtn = document.querySelector('.webshop-show-filters-button');
        if (showFiltersBtn) {
            showFiltersBtn.addEventListener('click', event => {
                event.preventDefault();
                const filtersList = document.querySelector('.webshop-filters-list, .webshop-edito-content-filters-list');
                filtersList.classList.toggle('hidden');
            });
        }
    }

    static showMoreEvents() {
        const moreBtnsElements = document.querySelectorAll('.ibexa-store-filters .ibexa-store-filter__more-btn');
        const IBEXA_STORE_FILTERS_MORE_BTNS_STATE = 'ibexa-store-filters-more-btns-state';
        const getMoreBtns = () => {
            return JSON.parse(localStorage.getItem(IBEXA_STORE_FILTERS_MORE_BTNS_STATE)) ?? [];
        };
        const setMoreBtns = data => {
            localStorage.setItem(IBEXA_STORE_FILTERS_MORE_BTNS_STATE, JSON.stringify(data));
        };

        const changeMoreBtnLabel = (moreBtn, isExpanded) => {
            const {showMore, showLess } = moreBtn.dataset;

            if (isExpanded) {
                moreBtn.innerHTML = showLess;
            } else {
                moreBtn.innerHTML = showMore;
            }
        };

        const toggleCheckboxVisibility = (moreBtn, isExpanded) => {
            const filterContainer = moreBtn.closest('.ibexa-store-filter');
            const filterChoices = filterContainer.querySelectorAll('.ibexa-store-choice.ibexa-store-choice--more');
            filterChoices.forEach(filterChoice => filterChoice.classList.toggle('ibexa-store-choice--hidden', !isExpanded));
        };

        const moreBtnToggle = ({currentTarget}) => {
            const moreBtns = getMoreBtns();
            const filterTitleName = currentTarget.dataset.typeName;
            const moreBtnIndex = moreBtns.findIndex(({type}) => type === filterTitleName);

            if (moreBtnIndex >= 0) {
                moreBtns[moreBtnIndex].isExpanded = !moreBtns[moreBtnIndex].isExpanded;
            } else {
                moreBtns.push({
                    type: filterTitleName,
                    isExpanded: true
                });
            }

            setMoreBtns(moreBtns);
            const isExpanded = moreBtnIndex !== -1 ? moreBtns[moreBtnIndex].isExpanded : true;
            toggleCheckboxVisibility(currentTarget, isExpanded);
            changeMoreBtnLabel(currentTarget, isExpanded);
        };

        const initMoreBtn = moreBtn => {
            const moreBtns = getMoreBtns();
            const filterTitleName = moreBtn.dataset.typeName;
            const moreBtnIndex = moreBtns.findIndex(({type}) => type === filterTitleName);

            if (moreBtnIndex === -1) {
                return;
            }

            const { isExpanded } = moreBtns[moreBtnIndex];
            toggleCheckboxVisibility(moreBtn, isExpanded);
            changeMoreBtnLabel(moreBtn, isExpanded);
        };

        if (moreBtnsElements) {
            moreBtnsElements.forEach(moreBtnElement => {
                moreBtnElement.addEventListener('click', moreBtnToggle, false);
                initMoreBtn(moreBtnElement);
                event.preventDefault();
            });
        }
    }

    static searchInEditoContent() {
        let productList = document.querySelector('.product-list-edito-content');
        if (productList) {
            Array
                .from(document.querySelectorAll('.webshop-edito-content-filters-list .ibexa-store-choice__label'))
                .forEach(button => button.addEventListener('click', event => {
                    let productList = document.querySelector('.product-list-edito-content');
                    let searchParams = decodeURIComponent(productList.getAttribute('data-search-params'));
                    if (searchParams) {
                        event.preventDefault();
                        let currentTarget = event.currentTarget;
                        let elementSibling = currentTarget.previousElementSibling;
                        let isActive = elementSibling.getAttribute('checked');

                        const targetFilterName = event.currentTarget.previousElementSibling.name;
                        const targetFilterLabel = event.currentTarget.previousElementSibling.value;
                        let tagSearch = '&' + targetFilterName + '=' + targetFilterLabel

                        if(!isActive) {
                            searchParams = searchParams + tagSearch;
                        } else {
                            searchParams = searchParams.replace(tagSearch, "");
                        }

                        const xhttp = new XMLHttpRequest();
                        xhttp.onload = function() {
                            if (this.responseText.includes('product-list-edito-content')) {
                                productList.parentElement.innerHTML = this.responseText;
                                Webshop.searchInEditoContent();
                                Webshop.showFiltersEvents();
                                Webshop.showMoreEvents();
                            }
                        }

                        xhttp.open("GET", (document.body.getAttribute('data-root-location') || '/') + "search-publications/api/html?" + searchParams);
                        xhttp.send();
                    }
                }));
        }
    }

}